import { SVGProps } from 'react';

export const IconExpand = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox='2 2 20 20' {...props}>
      <path
        d='M9.14294 9.50013L12 6.64307L14.8571 9.50013'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9.14294 14.4999L12 17.3569L14.8571 14.4999'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
